export default function Footer({ setCurrentPage }) {
  return (
    <footer 
      className="mt-5 py-5 position-relative" 
      style={{ 
        backgroundColor: 'var(--bg-base)', 
        borderTop: '1px solid rgba(255, 255, 255, 0.05)' 
      }}
    >
      <div className="container px-4">
        <div className="row justify-content-between mb-5">
          
          {/* Brand Column */}
          <div className="col-12 col-lg-5 mb-5 mb-lg-0">
            <div className="d-flex align-items-center gap-3 mb-3">
              <div 
                className="d-flex align-items-center justify-content-center rounded" 
                style={{ 
                  width: '40px', 
                  height: '40px', 
                  background: 'rgba(255, 255, 255, 0.03)', 
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  color: 'var(--accent)'
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h5 className="text-white fw-bold mb-0" style={{ letterSpacing: '-0.02em' }}>
                TapSecureX
              </h5>
            </div>
            <p className="text-muted pe-lg-5" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
              Advanced network-layer security client for Android. Intercepting threats deterministically before they reach the browser layer. Powered by Trinetra SentinelX.
            </p>
          </div>

          {/* Navigation Column */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="text-white mb-4 fw-semibold" style={{ fontSize: '0.9rem' }}>Platform</h6>
            <div className="d-flex flex-column gap-3">
              <span className="nav-link p-0" onClick={() => setCurrentPage("home")}>Overview</span>
              <span className="nav-link p-0" onClick={() => setCurrentPage("about")}>Architecture</span>
              <span className="nav-link p-0 text-muted" style={{ opacity: 0.5, cursor: 'not-allowed' }}>Release Notes</span>
            </div>
          </div>

          {/* Legal Column */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="text-white mb-4 fw-semibold" style={{ fontSize: '0.9rem' }}>Resources</h6>
            <div className="d-flex flex-column gap-3">
              <span className="nav-link p-0" onClick={() => setCurrentPage("privacy")}>Privacy Policy</span>
              <span className="nav-link p-0" onClick={() => setCurrentPage("contact")}>Contact Support</span>
              <span className="nav-link p-0 text-muted" style={{ opacity: 0.5, cursor: 'not-allowed' }}>Documentation</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div 
          className="row pt-4 align-items-center" 
          style={{ borderTop: '1px solid rgba(255, 255, 255, 0.05)' }}
        >
          <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
            <span className="text-muted" style={{ fontSize: '0.85rem' }}>
              &copy; {new Date().getFullYear()} TapSecureX. All rights reserved.
            </span>
          </div>
          <div className="col-md-6 d-flex justify-content-center justify-content-md-end">
            
            {/* Status Pill */}
            <div 
              className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill" 
              style={{ 
                backgroundColor: 'rgba(25, 135, 84, 0.08)', 
                border: '1px solid rgba(25, 135, 84, 0.2)' 
              }}
            >
              <span 
                className="bg-success rounded-circle" 
                style={{ width: "8px", height: "8px", boxShadow: "0 0 10px #198754" }}
              ></span>
              <span 
                className="text-success font-mono mb-0" 
                style={{ fontSize: '0.75rem', fontWeight: '600', letterSpacing: '0.02em' }}
              >
                SYSTEMS OPERATIONAL
              </span>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  );
}